import {API} from "aws-amplify";
import {awsApiName} from "../../shared/amplify/amplify-utils";
import {ScraperConfigResource} from "../../entity/resource/scraper-config-resource";

export default class ScraperConfigAgent {

    getScraperConfig = async (countyId: string): Promise<ScraperConfigResource[]> => {
        return await API.get(awsApiName, `/web-scraper-configs?name=${countyId}`, {});
    }
}
